import { LineItem } from '@vendasta/sales-orders';
import { Package } from '@vendasta/marketplace-packages';
import { App } from '@galaxy/marketplace-apps';
import { convertSelectedAppToLineItem, packageToUILineItem } from './shared/utils';
import { defaultCurrencyCodeUSD, INVALID_ITEM } from './shared/constants';
import { UILineItemWithEditionPricing } from './shared/interface';

// TODO: this needs to fit both PC and SSC (likely as an input from those clients once SSC starts using the lib components)
export const ORDER_FORM_FILE_UPLOAD_URL = '/_ajax/v1/marketplace/file/upload';

export function buildOrderItems(
  lineItems: LineItem[],
  packages: Package[] | any[],
  appsAndAddons: App[] | any[],
  defaultCurrency: string,
): UILineItemWithEditionPricing[] {
  return lineItems.map((li) => {
    let uiLineItem = INVALID_ITEM;
    if (li.packageId) {
      const pack = packages.find((p) => p.packageId === li.packageId);
      uiLineItem = packageToUILineItem(pack, defaultCurrency);
    } else {
      const app = appsAndAddons.find(
        (a) => a.key.appId === li.appKey.appId && (a.key.editionId || '') === (li.appKey.editionId || ''),
      );
      if (app) {
        uiLineItem = convertSelectedAppToLineItem(app, defaultCurrencyCodeUSD);
      }
    }
    uiLineItem.lineItem = li;
    return uiLineItem;
  });
}

export function getEarliestScheduledLineItemDate(lineItems: LineItem[]): Date | null {
  if (!lineItems || !lineItems.length) {
    return null;
  }
  let earliestDate: Date | null = null;
  lineItems.forEach((lineItem) => {
    const startDate = lineItem?.billingPeriod?.startDate;
    if (!startDate) return;
    // Normalize to local midnight
    const startDateLocalMidnight = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
    if (startDate) {
      if (!earliestDate || startDateLocalMidnight.getTime() < earliestDate.getTime()) {
        earliestDate = startDateLocalMidnight;
      }
    }
  });
  return earliestDate;
}
